import { projectRequest } from 'store/utils/request';

export const checkDictionaryNameRequest = (name, exception) =>
  projectRequest.get(`/dictionaries/`, {
    params: Object.assign(
      {
        name__iexact: name,
      },
      exception
        ? {
            id__not__in: exception,
          }
        : null,
    ),
  });

export const getDictionariesRequest = async params => {
  try {
    return await projectRequest.get(`/dictionaries/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addDictionaryRequest = async data => {
  try {
    return await projectRequest.post(`/dictionaries/`, data);
  } catch (error) {
    throw error;
  }
};

export const getDictionaryRequest = async id => {
  try {
    return await projectRequest.get(`/dictionaries/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const updateDictionaryRequest = async (id, data) => {
  try {
    return await projectRequest.put(`/dictionaries/${id}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteDictionaryRequest = async id => {
  try {
    return await projectRequest.delete(`/dictionaries/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const exportDictionaryRequest = async id => {
  try {
    return await projectRequest.get(
      `/dictionaries/${id}/export/`,
      {},
      {
        responseType: 'blob',
        timeout: 60000,
      },
    );
  } catch (error) {
    throw error;
  }
};
